import { useNavigate } from "react-router-dom";
import SecondaryBarView from "@wine2trace/ui/SecondaryBar";
import "./styles/index.scss";

// The view is in @wine2trace/ui; here the navigation. No winery first: the active one is in the header.
const SecondaryBar = ({ breadCrumb }) => {
  const navigate = useNavigate();

  return <SecondaryBarView breadCrumb={breadCrumb} onNavigate={navigate} />;
};

export default SecondaryBar;
